/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const roleTypeAdvancedNameSchema = z
  .enum(['None', 'User', 'Manager', 'Admin', 'Intern'])
  .describe('Member names of RoleTypeAdvanced.')
